import React from 'react';
import { TABLE_HEADER_SUBTEXT } from '@constants/commonConstants';
import { DateFiltering, DateSorting, OppsNameSorting } from '@util/commonFunctions';
import '@templates/gcsp/styles/styles.css';

const aggFunc = params => {
  if (params.rowNode.groupData['ag-Grid-AutoColumn']) {
    if (params.values.length !== 0) {
      const sum = params.values.reduce((acc, val) => acc + Number(val));
      return sum + Number(0);
    }
  }
};

const menuTabsItems = ['filterMenuTab'];
const cellTextAligment = { display: 'flex', justifyContent: 'flex-end' };

export const columnDefsKeys = [
  {
    headerName: 'PL Commit Status',
    field: 'category',
    cellRenderer: 'commitColumnRenderer',
    width: 150,
    rowGroup: true,
    hide: true,
    suppressMovable: true,
  },

  {
    headerName: 'Status',
    field: 'statuscode',
    cellRenderer: 'statusCellRenderer',
    filterValueGetter: params => {
      const statusMapping = {
        0: 'Open',
        1: 'Won',
        2: 'Lost',
        3: 'Declined',
      };
      return statusMapping[params.data?.statuscode] || '';
    },
    width: 120,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    suppressMovable: true,
    sortable: true,
  },
  {
    headerName: 'ID',
    field: 'ey_id',
    width: 120,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    suppressMovable: true,
  },
  {
    headerName: 'Pursuit Type',
    field: 'pursuit_type',
    cellRenderer: 'pursuitTypeCellRenderer',
    width: 170,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
  },
  {
    headerName: 'Opportunity Name',
    field: 'opportunityname',
    sortable: true,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    cellRenderer: 'textLinkRenderer',
    width: 170,
    suppressMovable: true,
    comparator: OppsNameSorting,
  },

  {
    headerName: 'AWD',
    field: 'AWD',
    sortable: true,
    menuTabs: menuTabsItems,
    filter: 'agDateColumnFilter',
    filterParams: DateFiltering,
    cellRenderer: 'awd_Field_Rendere',
    cellRendererParams: params => {
      const awd = params.data?.AWD;
      const month = params.data?.fiscal_month;
      return { awd, month };
    },
    headerComponentParams: {
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
    },
    width: 180,
    comparator: DateSorting,
    suppressMovable: true,
  },
  {
    headerName: 'Stage',
    field: 'stage_name',
    sortable: true,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    width: 130,
    suppressMovable: true,
    cellRenderer: params => {
      if (params.value && typeof params.value === 'string') {
        // Remove numeric prefixes (e.g., "10 -", "40 -", "30 -")
        return params.value.replace(/^\d+\s-\s/, '');
      }
      return ''; // Return an empty string if params.value is null or undefined
    },
  },
  {
    headerName: 'Prob.(%)',
    field: 'Prob',
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    cellRenderer: 'probCellRenderer',
    width: 140,
    suppressMovable: true,
  },
  {
    headerName: 'Pursuit Leader',
    field: 'PursuitLeader',
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    width: 185,
    suppressMovable: true,
    cellRenderer: params => {
      const value = params.value;
      if (value && typeof value === 'string') {
        // Return a React element with a tooltip
        return <span title={value}>{value.length > 15 ? value.slice(0, 15) + '...' : value}</span>;
      }
      return value || ''; // Return the original value or an empty string if null/undefined
    },
  },
  {
    headerName: 'Assurance',
    field: 'Assurance',
    sortable: true,
    headerComponentParams: {
      displayName: 'Assurance',
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.EXCL_ACR,
    },
    width: 140,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'Consulting',
    field: 'consulting',
    sortable: true,
    headerComponentParams: {
      displayName: 'Consulting',
      enableSorting: true,
    },
    width: 140,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'SAT',
    field: 'sat',
    sortable: true,
    headerComponentParams: {
      displayName: 'SAT',
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.EXCL_ITTS,
    },
    width: 140,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'Tax',
    field: 'tax',
    sortable: true,
    headerComponentParams: {
      displayName: 'Tax',
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.EXCL_ITTS,
    },
    width: 130,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'ITTS',
    field: 'itts',
    headerComponentParams: { displayName: 'ITTS', enableSorting: true },
    width: 130,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'EMEIA ACR',
    field: 'EMIAACR',
    sortable: true,
    headerComponentParams: { displayName: 'EMEIA ACR', enableSorting: true },
    width: 150,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'TOV',
    field: 'TOV',
    sortable: true,
    headerComponentParams: { displayName: 'TOV', enableSorting: true },
    width: 140,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer', // Modified truncation with tooltip
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
];
